import { render, staticRenderFns } from "./LatestDisclosureCard.vue?vue&type=template&id=5a489e79"
import script from "./LatestDisclosureCard.vue?vue&type=script&lang=js"
export * from "./LatestDisclosureCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseButton: require('/vercel/path0/components/ui/BaseButton.vue').default})
